//
//
//
//
//
//
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-num",
  props: {
    option: Object
  },
  inject: ['queryParam'],
  data: function data() {
    return {
      cptData: {},
      uuid: null
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "Num").then(function (res) {
        _this.cptData = res;
      });
    }
  }
};